import type {AxiosRequestConfig} from 'axios';

import {spotheroDelete} from 'api';
import {sendSentryException} from 'utils/error-handling';

/**
 * Deletes a comp pass
 *
 * @param facilityId - The id of the facility to delete the comp pass for
 * @param compPassId - The id of the comp pass to delete
 * @param config - Additional Axios configuration options for the request.
 * @param config.signal - An abort signal to cancel the request.
 *
 * @see '/api/v1/facilities/{facilityId}/comp-pass/passes/{compPassId}/'
 */
export const deleteCompPass = async (
    facilityId: number,
    compPassId: number,
    config: AxiosRequestConfig = {}
) => {
    try {
        await spotheroDelete(
            `facilities/${facilityId}/comp-pass/passes/${compPassId}/`,
            config
        );
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};
